<script>

import {
    MinLengthValidator,
    MaxLengthValidator,
    LengthValidator,
    EmailValidator,
    RegularExpressionValidator,
    NotEmptyValidator,
    DateValidator
} from "$vueCommon/classes/Validator.js";
import Validator from "$vueCommon/classes/Validator.js";
import SelectCountry from "$vueCommon/components/Select/SelectCountry.vue";
import SelectPhone from "$vueCommon/components/Select/SelectPhone.vue";
import CheckoutAPI from "$vueCommon/classes/API/CheckoutAPI.js";
import {ToastMessageDanger, ToastMessageSuccess, ToastMessageWarning} from "$vueCommon/classes/ToastMessage.js";
import eventBus from "vue3-eventbus";

export default {
    components: {SelectCountry, SelectPhone},
    props: {
        dnsProfile: Object,
        onConfirm: Function,
        onDismiss: Function
    },
    mounted() {
        this.localDnsProfile = {...this.dnsProfile};
        this.validator
            .add('name', (new NotEmptyValidator(this, 'localDnsProfile.name')).setMessage(this.$translate('validation.required', {attribute:this.$translate('manager-settings.dns_profile_name')})))
            .add('name', (new MaxLengthValidator(this, 'localDnsProfile.name', 255)).setMessage(this.$translate('validation.max.string', {attribute:this.$translate('manager-settings.dns_profile_name'), max:'255'})))
            .add('description', (new NotEmptyValidator(this, 'localDnsProfile.description')).setMessage(this.$translate('validation.required', {attribute:this.$translate('manager-settings.description')})))
            .add('description', (new MaxLengthValidator(this, 'localDnsProfile.description', 255)).setMessage(this.$translate('validation.max.string', {attribute:this.$translate('manager-settings.description'), max:'255'})))
            .add('dns_1', (new NotEmptyValidator(this, 'localDnsProfile.dns_1')).setMessage(this.$translate('validation.required', {attribute:'DNS 1'})))
            .add('dns_1', (new MaxLengthValidator(this, 'localDnsProfile.dns_1', 255)).setMessage(this.$translate('validation.max.string', {attribute:'DNS 1', max:'255'})))
            .add('dns_2', (new NotEmptyValidator(this, 'localDnsProfile.dns_2')).setMessage(this.$translate('validation.required', {attribute:'DNS 2'})))
            .add('dns_2', (new MaxLengthValidator(this, 'localDnsProfile.dns_2', 255)).setMessage(this.$translate('validation.max.string', {attribute:'DNS 2', max:'255'})))
            .add('dns_3', (new MaxLengthValidator(this, 'localDnsProfile.dns_3', 255)).setMessage(this.$translate('validation.max.string', {attribute:'DNS 3', max:'255'})))
            .add('dns_4', (new MaxLengthValidator(this, 'localDnsProfile.dns_4', 255)).setMessage(this.$translate('validation.max.string', {attribute:'DNS 4', max:'255'})))
            .add('dns_5', (new MaxLengthValidator(this, 'localDnsProfile.dns_5', 255)).setMessage(this.$translate('validation.max.string', {attribute:'DNS 5', max:'255'})))
    },
    data() {
        return {
            localDnsProfile: {},
            validator: new Validator(),
            touched: {
                prefix: false,
                phone: false
            },
            saving: false,
            backendErrors: {}
        }
    },
    methods: {
        save() {
            this.backendErrors = {};

            if (!this.validator.validate()) {
                ToastMessageWarning.emit(this.$translate('checkout.please_correct_errors_in_form'), 1500);
    
                return false;
            }

            this.saving = true;
            CheckoutAPI.postSaveUserDnsProfile(this.localDnsProfile).then((response) => {
                eventBus.emit('refreshDnsProfile', response);
                this.onConfirm(response.id);
                this.saving = false;

                ToastMessageSuccess.emit(this.$translate('checkout.dns_profile_has_been_saved'));

                return true;
            }, (errorResponse) => {
                this.saving = false;

                if (errorResponse.response && errorResponse.response.status === 422) {
                    const backendErrors = errorResponse.response.data.errors || {};

                    this.backendErrors = backendErrors;

                    Object.keys(backendErrors).forEach(field => {
                        this.validator.setTouched(field);
                    });

                    ToastMessageWarning.emit(this.$translate('checkout.please_correct_errors_in_form'), 1500);
                } else {
                    ToastMessageDanger.emit(this.$translate('domains.unexpected_error_occurred'));
                }

                return false;
            });
        },

        allMessages(field) {
            const validatorMessages = this.validator.getMessages(field).map(m => m.message);
            const backendMessages = this.backendErrors[field] || [];
            return [...validatorMessages, ...backendMessages];
        }
    },
    computed: {
        isValidName() {
            const hasBackend = this.backendErrors.name && this.backendErrors.name.length;

            return (this.validator.isValid('name') && !hasBackend) || !this.validator.isTouched('name');
        },
        isValidDescription() {
            const hasBackend = this.backendErrors.description && this.backendErrors.description.length;

            return (this.validator.isValid('description') && !hasBackend) || !this.validator.isTouched('description');
        },

        isValidDns1() {
            const hasBackend = this.backendErrors.dns_1 && this.backendErrors.dns_1.length;

            return (this.validator.isValid('dns_1') && !hasBackend) || !this.validator.isTouched('dns_1');
        },
        isValidDns2() {
            const hasBackend = this.backendErrors.dns_2 && this.backendErrors.dns_2.length;

            return (this.validator.isValid('dns_2') && !hasBackend) || !this.validator.isTouched('dns_2');
        },
        isValidDns3() {
            const hasBackend = this.backendErrors.dns_3 && this.backendErrors.dns_3.length;
    
            return (this.validator.isValid('dns_3') && !hasBackend) || !this.validator.isTouched('dns_3');
        },
        isValidDns4() {
            const hasBackend = this.backendErrors.dns_4 && this.backendErrors.dns_4.length;

            return (this.validator.isValid('dns_4') && !hasBackend) || !this.validator.isTouched('dns_4');
        },
        isValidDns5() {
            const hasBackend = this.backendErrors.dns_5 && this.backendErrors.dns_5.length;

            return (this.validator.isValid('dns_5') && !hasBackend) || !this.validator.isTouched('dns_5');
        }
    }
}
</script>

<template>
    <div class="component-identity-add-edit">
        <div class="row mb-3">
            <div class="col-12">
                <div class="input-group" :class="{'is-invalid': !isValidName}">
                    <span class="input-group-text">
                        <i class="fas fa-tag fa-fw"></i>
                    </span>
                    <div :class="{'form-floating': true, 'is-invalid': !isValidName}">
                        <input type="text" class="form-control" id="name" name="name"
                            v-model="localDnsProfile.name" @focusout="validator.setTouched('name')"
                            :class="{'is-invalid': !isValidName}"
                            :placeholder="$translate('manager-settings.dns_profile_name')">
                        <label for="name">{{ $translate('manager-settings.dns_profile_name') }}</label>
                    </div>
                </div>
                <template v-if="!isValidName">
                    <div v-for="message in allMessages('name')" :key="message" class="invalid-feedback">
                        {{ message }}
                    </div>
                </template>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <div class="input-group" :class="{'is-invalid': !isValidDescription}">
                    <span class="input-group-text">
                        <i class="fas fa-align-left fa-fw"></i>
                    </span>
                    <div :class="{'form-floating': true, 'is-invalid': !isValidDescription}">
                        <input type="text" class="form-control" id="description" name="description"
                            v-model="localDnsProfile.description" @focusout="validator.setTouched('description')"
                            :class="{'is-invalid': !isValidDescription}"
                            :placeholder="$translate('manager-settings.description')">
                        <label for="description">{{ $translate('manager-settings.description') }}</label>
                    </div>
                </div>
                <template v-if="!isValidDescription">
                    <div v-for="message in allMessages('description')" :key="message" class="invalid-feedback">
                        {{ message }}
                    </div>
                </template>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <div class="input-group" :class="{'is-invalid': !isValidDns1}">
                    <span class="input-group-text">
                        <i class="fas fa-server fa-fw"></i>
                    </span>
                    <div :class="{'form-floating': true, 'is-invalid': !isValidDns1}">
                        <input type="text" class="form-control" id="dns_1" name="dns_1"
                            v-model="localDnsProfile.dns_1" @focusout="validator.setTouched('dns_1')"
                            :class="{'is-invalid': !isValidDns1}"
                            placeholder="DNS 1">
                        <label for="dns_1">DNS 1</label>
                    </div>
                </div>
                <template v-if="!isValidDns1">
                    <div v-for="message in allMessages('dns_1')" :key="message" class="invalid-feedback">
                        {{ message }}
                    </div>
                </template>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <div class="input-group" :class="{'is-invalid': !isValidDns2}">
                    <span class="input-group-text">
                        <i class="fas fa-network-wired fa-fw"></i>
                    </span>
                    <div :class="{'form-floating': true, 'is-invalid': !isValidDns2}">
                        <input type="text" class="form-control" id="dns_2" name="dns_2"
                            v-model="localDnsProfile.dns_2" @focusout="validator.setTouched('dns_2')"
                            :class="{'is-invalid': !isValidDns2}"
                            placeholder="DNS 2">
                        <label for="dns_2">DNS 2</label>
                    </div>
                </div>
                <template v-if="!isValidDns2">
                    <div v-for="message in allMessages('dns_2')" :key="message" class="invalid-feedback">
                        {{ message }}
                    </div>
                </template>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <div class="input-group" :class="{'is-invalid': !isValidDns3}">
                    <span class="input-group-text">
                        <i class="fas fa-sitemap fa-fw"></i>
                    </span>
                    <div :class="{'form-floating': true, 'is-invalid': !isValidDns3}">
                        <input type="text" class="form-control" id="dns_3" name="dns_3"
                            v-model="localDnsProfile.dns_3" @focusout="validator.setTouched('dns_3')"
                            :class="{'is-invalid': !isValidDns3}"
                            :placeholder="`DNS 3 (${$translate('checkout.optional')})`">
                        <label for="dns_3">DNS 3 ({{ $translate('checkout.optional') }})</label>
                    </div>
                </div>
                <template v-if="!isValidDns3">
                    <div v-for="message in allMessages('dns_3')" :key="message" class="invalid-feedback">
                        {{ message }}
                    </div>
                </template>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <div class="input-group" :class="{'is-invalid': !isValidDns4}">
                    <span class="input-group-text">
                        <i class="fas fa-project-diagram fa-fw"></i>
                    </span>
                    <div :class="{'form-floating': true, 'is-invalid': !isValidDns4}">
                        <input type="text" class="form-control" id="dns_4" name="dns_4"
                            v-model="localDnsProfile.dns_4" @focusout="validator.setTouched('dns_4')"
                            :class="{'is-invalid': !isValidDns4}"
                            :placeholder="`DNS 4 (${$translate('checkout.optional')})`">
                        <label for="dns_4">DNS 4 ({{ $translate('checkout.optional') }})</label>
                    </div>
                </div>
                <template v-if="!isValidDns4">
                    <div v-for="message in allMessages('dns_4')" :key="message" class="invalid-feedback">
                        {{ message }}
                    </div>
                </template>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <div class="input-group" :class="{'is-invalid': !isValidDns5}">
                    <span class="input-group-text">
                        <i class="fas fa-share-alt fa-fw"></i>
                    </span>
                    <div :class="{'form-floating': true, 'is-invalid': !isValidDns5}">
                        <input type="text" class="form-control" id="dns_5" name="dns_5"
                            v-model="localDnsProfile.dns_5" @focusout="validator.setTouched('dns_5')"
                            :class="{'is-invalid': !isValidDns5}"
                            :placeholder="`DNS 5 (${$translate('checkout.optional')})`">
                        <label for="dns_5">DNS 5 ({{ $translate('checkout.optional') }})</label>
                    </div>
                </div>
                <template v-if="!isValidDns5">
                    <div v-for="message in allMessages('dns_5')" :key="message" class="invalid-feedback">
                        {{ message }}
                    </div>
                </template>
            </div>
        </div>

        <div class="component-footer-wrapper">
            <div class="row component-footer">
                <div class="col-6">
                    <button class="btn btn-circle w-100" @click="onDismiss()">{{ $translate('checkout.cancel') }}</button>
                </div>
                <div class="col-6">
                    <button class="btn btn-primary w-100" @click="save()" :class="{disabled: saving}">
                        <template v-if="!saving">{{ $translate('checkout.save') }}</template>
                        <div v-if="saving" class="vue-loader"></div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
